import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import WrapperIpad from "../components/layout/WrapperIpad";
import PlayerIpadControls from "../components/featurematch/PlayerIpadControls";
import PlayerIpadDecklist from "../components/featurematch/PlayerIpadDecklist";

//HOOKS
import useFeatureMatchHandler from "../hooks/useFeatureMatchHandler";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function DashboardTable() {
   let { tableId } = useParams();
   
   const resetLifeTotal = () => {
      if (window.confirm("Are you sure you want to reset life totals to 20?\n\nMake sure that the commentators have time to review at the end of a match.")) {
         update(tableId, { ["LifeTotalP1"]: 20 })
         update(tableId, { ["LifeTotalP2"]: 20 })
      }
   }

   // USE SOCKETS HOOK
   const [
      players,
      activeDecklist,
      allPlayers,
      gameState,
      cardsInHand,
      update,
      lastUpdated,
      saveRequired,
      needsSave,
      { subscribeFeatureMatch, saveUpdates, getAllPlayers, cancelUpdates, getDecklist, clearActiveDecklist },
   ] = useFeatureMatchHandler();

   useEffect(() => {
      subscribeFeatureMatch(tableId);
      getAllPlayers();
   }, [tableId]);

   const playerName = (playerId) => {
      const playerData = _.find(players, {
         id: playerId,
      });

      if (playerData) {
         return playerData.PlayerName;
      } else {
         return "";
      }
   };

   const playerPronouns = (playerId) => {
      const playerData = _.find(players, {
         id: playerId,
      });

      if (playerData) {
         return playerData.PREFERRED_PRONOUNS;
      } else {
         return "";
      }
   };

   const playerDecklist = (playerId) => {
      const playerData = _.find(players, {
         id: playerId,
      });

      if (playerData) {
         if (playerData.decklist) {
            return playerData.decklist;
         } else {
            return null;
         }
      } else {
         return null
      }
   };

   return (
      <WrapperIpad key={"ipadInterface" + tableId}>
         {activeDecklist && (
            <PlayerIpadDecklist decklist={activeDecklist} close={() => clearActiveDecklist()} />
         )}

         <Typography
            variant='h6'
            component='div'
            sx={{
               textAlign: "center",
               textTransform: "uppercase",
               position: "fixed",
               bottom: 20,
               right: 20,
               color: "#555",
               zIndex: 100,
            }}
         >
            Feature Match Table {tableId}
         </Typography>

         <Box sx={{ width: "100%", height: "100%" }}>
            {saveRequired && (
               <Stack
                  direction='row'
                  spacing={2}
                  sx={{
                     width: "100%",
                     position: "absolute",
                     top: 0,
                     zIndex: 100,
                     p: 2,
                  }}
               >
                  <Button
                     variant='contained'
                     color='error'
                     sx={{
                        fontSize: "2vw",
                     }}
                     onClick={() => saveUpdates(tableId)}
                     fullWidth
                  >
                     SAVE CHANGES
                  </Button>

                  <Button
                     variant='contained'
                     color='secondary'
                     sx={{
                        fontSize: "2vw",
                     }}
                     onClick={() => cancelUpdates(tableId)}
                  >
                     CANCEL
                  </Button>
               </Stack>
            )}

            {gameState && (
               <Grid container sx={{ p: 0, width: "100%", height: "100%" }}>
               
               <Button
                  key={"decrement5"}
                  variant='ipadButton'
                  onClick={() => resetLifeTotal()}
                  sx={{ position: "absolute", top: "10vw", left: "50%", transform: "translateX(-50%)", zIndex: 100, width: "20vw", fontSize: "2vw" }}
               >
                  Reset
               </Button>
                  <Grid
                     item
                     xs={6}
                     sx={{
                        backgroundColor: "#111",
                        textAlign: "center",
                        overflow: "hidden",
                        position: "relative",
                     }}
                  >
                     <PlayerIpadControls
                        gameState={gameState}
                        player={2}
                        tableId={tableId}
                        playerName={playerName(gameState["PlayerIdP2"])}
                        playerDecklist={playerDecklist(gameState["PlayerIdP2"])}
                        pronouns={playerPronouns(gameState["PlayerIdP2"])}
                        getDecklist={getDecklist}
                        callback={update}
                     />
                  </Grid>
                  <Grid
                     item
                     xs={6}
                     sx={{
                        backgroundColor: "#000",
                        textAlign: "center",
                        position: "relative",
                     }}
                  >
                     <PlayerIpadControls
                        gameState={gameState}
                        player={1}
                        tableId={tableId}
                        playerName={playerName(gameState["PlayerIdP1"])}
                        playerDecklist={playerDecklist(gameState["PlayerIdP1"])}
                        pronouns={playerPronouns(gameState["PlayerIdP1"])}
                        getDecklist={getDecklist}
                        callback={update}
                     />
                  </Grid>
               </Grid>
            )}
         </Box>
      </WrapperIpad>
   );
}
